export default "__VITE_ASSET__wweN$50u__"